import type { VideoProvider, VideoResolver } from "./types";

export function createVideoResolver(
  providers: readonly VideoProvider[],
): VideoResolver {
  return (value, context = {}) => {
    const trimmed = value.trim();
    if (!trimmed || trimmed.length > 2000 || /[\s\\]/u.test(trimmed))
      return null;
    try {
      const url = new URL(trimmed);
      if (
        !/^https:\/\//i.test(trimmed) ||
        url.protocol !== "https:" ||
        url.username ||
        url.password
      )
        return null;
      if (url.port) return { url: url.href, embed: null };
      for (const provider of providers) {
        const embed = provider.resolve(url, context);
        if (embed) return { url: url.href, embed };
      }
      return { url: url.href, embed: null };
    } catch {
      return null;
    }
  };
}
